import { render, staticRenderFns } from "./DetailUsedPartFromRequestDataEachLab.vue?vue&type=template&id=2d1cd69d&scoped=true"
import script from "./DetailUsedPartFromRequestDataEachLab.vue?vue&type=script&lang=js"
export * from "./DetailUsedPartFromRequestDataEachLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1cd69d",
  null
  
)

export default component.exports